import React, { useEffect, useCallback } from "react";
import {
    Form,
    Modal,
    Typography,
    Col,
    Row,
} from "antd";
import RecipeApi from "../../Apis/RecipeApi";
import StockApi from "../../Apis/StockApi";

const { Title } = Typography;

function HistoryProduct({ visible, onClose, ProductionData, ProductionData2 }) {

    const [formAdd] = Form.useForm();
    
    function formatDate(date) {
        if (!date) return '-';
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(date).toLocaleDateString("en-US", options);
        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }
    
    function convertUnixToTime2(unixTimestamp) {
        const timestampMillis = unixTimestamp * 1000;
        const date = new Date(timestampMillis);
        const timeString = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
        return timeString;
    }
    
    const [Recipes, setRecipes] = React.useState([]);
    const [expiry, setExpiry] = React.useState([]);

    const getRecipe = useCallback(() => {
        RecipeApi.SingleRecipe(ProductionData2?.recipeDTO?.id)
            .then((response) => {
                setRecipes(response?.payload)
            })
            .catch((err) => {
                console.log(err);
            });
    }, [ProductionData2]);

    const getExpiryDate = useCallback(async () => {
        const stockBatchCodeList = ProductionData?.productionDTO?.stockBatchCodeList || [];

        if (!stockBatchCodeList.length) {
            setExpiry([]);
            return;
        }

        try {
            const expiryDates = await Promise.all(
                stockBatchCodeList.map(async (item) => {
                    let batchCode = item;
                    let stockId = null;
                    
                    // Parse the item if it contains the // separator
                    if (item && item.includes('//')) {
                        const parts = item.split('//');
                        batchCode = parts[0];
                        stockId = parts[1];
                    }
                    
                    try {
                        const response = await StockApi.ListBatchCode(batchCode);
                        const stocks = response?.payloadDto || [];
                        
                        if (stocks.length === 0) return null;
                        
                        // If we have a stock ID, find the matching stock
                        if (stockId) {
                            const matchedStock = stocks.find(s => s.id === parseInt(stockId));
                            if (matchedStock) {
                                return matchedStock.expiryDate;
                            }
                        }
                        
                        // Fallback: if no stock ID match, try to find the stock with the most quantity
                        // This is a fallback for backward compatibility
                        if (stocks.length > 0) {
                            // Sort by quantity (most stock first) and return the first
                            const sortedByQuantity = [...stocks].sort((a, b) => {
                                const qtyA = parseFloat(a.unitOfMeasurement1) || 0;
                                const qtyB = parseFloat(b.unitOfMeasurement1) || 0;
                                return qtyB - qtyA;
                            });
                            return sortedByQuantity[0]?.expiryDate || null;
                        }
                        
                        return null;
                        
                    } catch (err) {
                        console.error(`Error fetching batch ${batchCode}:`, err);
                        return null;
                    }
                })
            );

            setExpiry(expiryDates);
            console.log("Expiry dates with stock IDs:", expiryDates);
            
        } catch (err) {
            console.error(err);
        }
    }, [ProductionData]);

    useEffect(() => {
        getRecipe();
        getExpiryDate();
    }, [getRecipe, getExpiryDate]);

    const handleCancel = () => {
        formAdd.resetFields();
        onClose();
    };
    
    function formattedDate2(time) {
        const timeNew = parseInt(time, 10);
        const options = { hour: "2-digit", minute: "2-digit" };
        const formattedTime = new Date(timeNew).toLocaleTimeString(
            "en-US",
            options
        );
        return formattedTime;
    }
    
    function convertToAMPM(timeString) {
        if (!timeString) return '';
        const [hours, minutes] = timeString.split(':');
        let formattedHours = parseInt(hours, 10);
        const ampm = formattedHours >= 12 ? 'PM' : 'AM';
        formattedHours = formattedHours % 12 || 12;
        const formattedMinutes = minutes.padStart(2, '0');
        return `${formattedHours}:${formattedMinutes} ${ampm}`;
    }

    return (
        <>
            <Modal
                footer={[]}
                width={800}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    History of the Product
                </Title>

                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                >
                    <Row gutter={24} className="d-flex" style={{ justifyContent: 'center' }}>
                        <Col span={10}>
                            <div className="HistoryTitle mb-4">
                                <p className="mb-0 text-center" style={{color:"black", fontWeight:"bold"}}>
                                    {ProductionData?.productionDTO?.productionName} ({ProductionData?.productionDTO?.batchCode})
                                </p>
                            </div>
                        </Col>
                    </Row>
                    
                    <Row gutter={24}>
                        <Col span={12}>
                            <p className="mb-1 text-center">Production</p>
                            <div className="CardHistory">
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ display: 'flex', marginBottom: '5px' }}>
                                        <div style={{ flex: 1 }}>Date</div>
                                        <div style={{ flex: 1.8, textAlign: 'start' }}>: {formatDate(ProductionData?.productionDTO?.productionCreateDate)}</div>
                                    </div>
                                    <div style={{ display: 'flex', marginBottom: '5px' }}>
                                        <div style={{ flex: 1 }}>Time</div>
                                        <div style={{ flex: 1.8, textAlign: 'start' }}>: {convertToAMPM(ProductionData?.productionDTO?.cookingTime)}</div>
                                    </div>
                                    <div style={{ display: 'flex', marginBottom: '5px' }}>
                                        <div style={{ flex: 1 }}>Sell By Date</div>
                                        <div style={{ flex: 1.8, textAlign: 'start' }}>: {formatDate(ProductionData?.productionDTO?.sellByDate)}</div>
                                    </div>
                                    <div style={{ display: 'flex', marginBottom: '5px' }}>
                                        <div style={{ flex: 1 }}>Qty</div>
                                        <div style={{ flex: 1.8, textAlign: 'start' }}>: {ProductionData2?.quantity} {ProductionData2?.unit}</div>
                                    </div>
                                    <div style={{ display: 'flex', marginBottom: '5px' }}>
                                        <div style={{ flex: 1 }}>Allergens</div>
                                        <div style={{ flex: 1.8, textAlign: 'start' }}>: {ProductionData2?.allergensDTO?.map(item => item?.allergensName)?.join(' / ')}</div>
                                    </div>
                                    <div style={{ display: "flex", marginBottom: "5px" }}>
                                        <div style={{ flex: 1 }}>Ingredients</div>
                                        <div style={{ flex: 1.8, textAlign: "start" }}>
                                            {Recipes?.ingredientsDTO?.map((item, index) => (
                                                <div key={index} style={{ marginBottom: "8px" }}>
                                                    <div>{item?.name}</div>
                                                    <div>({item?.quantity} {item?.unit})</div>
                                                    <div>
                                                        OUBD :{" "}
                                                        {expiry[index]
                                                            ? formatDate(expiry[index])
                                                            : "-"}
                                                    </div>
                                                 
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={12} style={{ borderLeft: '2px solid gray' }}>
                        </Col>
                    </Row>
                    
                    <Row gutter={24}>
                        <Col span={12}>
                        </Col>
                        <Col span={12} style={{ borderLeft: '2px solid gray' }}>
                            <p className="mb-1 text-center">After Cook</p>
                            {ProductionData?.afterCookDTOList && ProductionData.afterCookDTOList.map((obj, index) => (
                                <div key={index} className="CardHistory">
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Date</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {formatDate(obj?.dateOfCooking)}</div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Time</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {convertToAMPM(obj?.timeOfCookingFinished)}</div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>OUBD</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {(obj?.oubd) ? formatDate(obj?.oubd) : ''}</div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Temperature</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {obj?.temperatureOfTheProductAfterCook !== 'N/A' ? obj?.temperatureOfTheProductAfterCook + ' °C' : "N/A"} </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col span={12}>
                            <p className="mb-1 text-center">Cooling Process</p>
                            {ProductionData?.coolingProcessDTOList && ProductionData.coolingProcessDTOList.map((obj, index) => (
                                <div key={index} className="CardHistory">
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Date</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {formatDate(obj?.createdDate)}</div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Time 1</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {convertUnixToTime2(obj?.temperatureTakenTime1)}</div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Temp 1</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {obj?.temperatureInCelsius1 ? obj?.temperatureInCelsius1 + ' °C' : "N/A"}  </div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Time 2</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {obj?.temperatureTakenTime2 ? convertUnixToTime2(obj?.temperatureTakenTime2) : "N/A"}  </div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Temp 2</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {obj?.temperatureInCelsius2 ? obj?.temperatureInCelsius2 + ' °C' : "N/A"} </div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Sell By Date</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {formatDate(ProductionData?.productionDTO?.sellByDate)}</div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Col>
                        <Col span={12} style={{ borderLeft: '2px solid gray' }}>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col span={12}>
                        </Col>
                        <Col span={12} style={{ borderLeft: '2px solid gray' }}>
                            <p className="mb-1 text-center">Reheat</p>
                            {ProductionData?.reheatProcessDTOList && ProductionData.reheatProcessDTOList.map((obj, index) => (
                                <div key={index} className="CardHistory">
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Date</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {formatDate(obj?.createdDate)}</div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Time</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {formattedDate2(obj?.createdDate)}</div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Temperature</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {obj?.temperatureInCelsius ? obj?.temperatureInCelsius + ' °C' : "N/A"} </div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Quantity</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {ProductionData2?.quantity} {ProductionData2?.unit} </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Col>
                    </Row>
                    
                    <Row gutter={24}>
                        <Col span={12}>
                            <p className="mb-1 text-center">Waste</p>
                            {ProductionData?.productionWasteDTOList && ProductionData.productionWasteDTOList.map((obj, index) => (
                                <div key={index} className="CardHistory">
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Date</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {formatDate(obj?.createdDate)}</div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Quantity</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {obj?.quantity} {obj?.unit} </div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Cook Name</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {obj?.cookName} </div>
                                        </div>
                                        <div style={{ display: 'flex', marginBottom: '5px' }}>
                                            <div style={{ flex: 1 }}>Reason</div>
                                            <div style={{ flex: 1.8, textAlign: 'start' }}>: {obj?.reason} </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Col>
                        <Col span={12} style={{ borderLeft: '2px solid gray' }}>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
}

export default HistoryProduct;